<template>
  <div class="input-box" >
    <input class="hidden-input" @input="inputCode" ref="inputDom" :value="modelValue" type="number" maxlength="6" @onclick="getmInputFocus" />

    <div class="vcode-parts" @onclick="getmInputFocus">
        <div class="vcode-input" v-for="i in 6" :key="i" @onclick="getmInputFocus">
            <div v-if="i < (modelValue.length + 1)"  @onclick="getmInputFocus">
                <span @onclick="getmInputFocus">{{getCurrSpan(i - 1)}}</span>
            </div>

            <div class="input-cursor" v-if="i === (modelValue.length + 1)" @onclick="getmInputFocus">
                <span @onclick="getmInputFocus">|</span>
            </div>
        </div>
    </div>
  </div>
</template>

<script setup>
  import {inject, ref} from "vue";

  const props = defineProps(['modelValue'])
  const emits = defineEmits(['update:modelValue'])

  const i18n = inject("i18n")
  const inputDom = ref(null)

  function inputCode(e){
    emits('update:modelValue', e.target.value)
  }

  function getCurrSpan(index) {
    return props.modelValue.charAt(index)
  }
  function getmInputFocus(){
    inputDom.value.focus()
  }

  function focusInput(){
      inputDom.value.focus()
  }

  defineExpose({
      focusInput
  })

</script>

<style scoped>
    .input-box {
        width: 100%;
        position: relative;
        height: 38px;
        text-align: center;
    }

    .input-box .hidden-input {
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        height: 38px;
        width: 100%;
    }

    .vcode-parts {
        display: flex;
        font-size: 18px;
        line-height: 34px;
        align-items: center;
        justify-content: space-around;
    }

    .input-cursor {
        animation: cursor-flicker 1s linear infinite;;
    }

    @keyframes cursor-flicker {
        0% {
            opacity: 1;
        }

        50% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    .vcode-input {
        width: 12%;
        height: 2em;
        border-bottom: 2px solid #9f9f9f;
    }

    .vcode-input{
      background-color: #FFFFFF;
      border-radius: 10px;
    }
</style>